import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlyingInsectLadybug = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "flying-insect-ladybug" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12.022,
			cy: 14.25,
			r: 9
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M7.534,6.447C7.341,2.9,9.425,1.5,12.022,1.5S16.7,2.9,16.51,6.447"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9.074,
			y1: 2.354,
			x2: 8.272,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 14.97,
			y1: 2.354,
			x2: 15.772,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12.022,
			y1: 5.25,
			x2: 12.022,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12.022,
			cy: 14.25,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.143,10.371A3,3,0,1,1,15.9,6.129"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.9,22.371a3,3,0,1,1,4.242-4.242"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8.143,6.129A3,3,0,0,1,3.9,10.371"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.9,18.129a3,3,0,0,1,4.242,4.242"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.463,20.536,19.44,22a2.8,2.8,0,0,0,2.332,1.248"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.754,8.277l.686-1.029A2.8,2.8,0,0,1,21.772,6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.76,
			y1: 12.087,
			x2: 23.272,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.562,
			y1: 17.097,
			x2: 23.272,
			y2: 18
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M5.581,20.536,4.6,22A2.8,2.8,0,0,1,2.272,23.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M5.29,8.277,4.6,7.248A2.8,2.8,0,0,0,2.272,6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.284,
			y1: 12.087,
			x2: .772,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.481,
			y1: 17.097,
			x2: .772,
			y2: 18
		})
	]
});
export default SvgFlyingInsectLadybug;
